import { FlexibleBlockBrick, FlexibleBlockModifierBrick } from '@nx-frontend/shared/types';

export const getBrickModifications = (
  bricksCurrnet: FlexibleBlockBrick[],
  brikcsDefault: FlexibleBlockBrick[]
): FlexibleBlockModifierBrick[] => {
  const modifications = bricksCurrnet.reduce<FlexibleBlockModifierBrick[]>((acc, brick) => {
    const brickDefault = brikcsDefault.find(({ brickType }) => brickType === brick.brickType);

    if (brickDefault == null) {
      return acc;
    }

    if (brick.brickType === 'image' && brick.brickType === brickDefault.brickType) {
      if (brick.src !== brickDefault.src && brick.src?.startsWith('https://')) {
        acc.push({
          brickType: brick.brickType,
          src: brick.src,
        });
      }
      return acc;
    }

    if (brick.brickType === 'title' && brick.brickType === brickDefault.brickType) {
      if (brick.text !== brickDefault.text) {
        acc.push({
          brickType: brick.brickType,
          text: brick.text,
        });
      }
      return acc;
    }

    if (brick.brickType === 'text' && brick.brickType === brickDefault.brickType) {
      if (brick.text !== brickDefault.text) {
        acc.push({
          brickType: brick.brickType,
          text: brick.text,
        });
      }
      return acc;
    }

    if (brick.brickType === 'search' && brick.brickType === brickDefault.brickType) {
      if (brick.placeholder !== brickDefault.placeholder) {
        acc.push({
          brickType: brick.brickType,
          placeholder: brick.placeholder,
        });
      }
      return acc;
    }

    return acc;
  }, []);

  return modifications;
};
